import { render, staticRenderFns } from "./AdvancementPath.component.vue?vue&type=template&id=5ebe5d36&scoped=true&"
import script from "./AdvancementPath.component.vue?vue&type=script&lang=ts&"
export * from "./AdvancementPath.component.vue?vue&type=script&lang=ts&"
import style0 from "./AdvancementPath.component.vue?vue&type=style&index=0&id=5ebe5d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe5d36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
